const lngUrl = () => {
    const urlPart = window.location.pathname.substr(1, 2);
    let lng = 'ru';
    if (urlPart && (urlPart === 'en' || urlPart === 'ru' || urlPart === 'md')) {
        lng = urlPart;
    }
    return lng;
}

export default lngUrl;